// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__8O_i7","error":"Textarea_error__23QcV","readonly":"Textarea_readonly__2oS-s","disabled":"Textarea_disabled__1S8mc"};